

<template>
  <div class="row bg-white boxpadding">
    <div
      class="col-lg-6 col-md-6 col-sm-12 d-flex color-desc-gray flex-column justify-content-center align-items-start"
    >
      <div>{{ tabData.desc }}</div>
      <div class="list mt--10">
        <div v-for="(item, index) in tabData.list" :key="index">
          <!-- <div class="icon">
            <img src="@/assets/images/singleHome/check.svg" alt="" />
          </div> -->
          <div class="content">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="offset-lg-1 offset-md-1 col-lg-5 col-md-5 col-sm-12">
      <img class="w-100" :src="src" :alt="tabData.title" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TabContent",
  props: {
    tabData: {
      type: Object,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
  },
};
</script>
